module.exports = __webpack_public_path__ + "static/roboto-bold-5cc86407ce0a05d9a640a35893e5f1b3.woff2";